module.exports = __webpack_public_path__ + "img/full-disclosure.3bf5ea82.png";